import { Loader2, Printer, Eye, Edit2, Trash2 } from "lucide-react";

export default function StudentTable({ 
  students, 
  loading, 
  onPrint, 
  onView, 
  onEdit, 
  onDelete,
  currentPage,
  totalPages,
  onPageChange
}) {
  if (loading) return (
    <div className="py-12 text-center bg-white rounded-[1.5rem] border border-slate-100">
      <Loader2 className="animate-spin text-orange-500 mx-auto" size={24} />
    </div>
  );

  console.log("Rendering StudentTable with students:", currentPage, totalPages, onPageChange);
  return (
    <div className="bg-white rounded-[1.5rem] border border-slate-100 shadow-sm overflow-hidden print:hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-slate-50 border-b border-slate-100">
              <th className="px-6 py-3 text-[10px] font-black text-slate-400 uppercase tracking-widest">Student</th>
              <th className="px-4 py-3 text-[10px] font-black text-slate-400 uppercase tracking-widest">Admission Date</th>
              <th className="px-4 py-3 text-[10px] font-black text-slate-400 uppercase tracking-widest">Course</th>
              <th className="px-4 py-3 text-[10px] font-black text-slate-400 uppercase tracking-widest">Status</th>
              <th className="px-4 py-3 text-[10px] font-black text-slate-400 uppercase tracking-widest text-right">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-50">
            {students.length === 0 ? (
              <tr>
                <td colSpan="5" className="px-6 py-10 text-center text-sm text-slate-400">
                  No records found.
                </td>
              </tr>
            ) : (
              students.map((student) => (
                <tr key={student.id} className="hover:bg-slate-50/80 transition-all">
                  <td className="px-6 py-3 font-bold text-sm">{student.full_name}</td>
                  <td className="px-6 py-3 font-bold text-sm">{student.admission_date}</td>
                  <td className="px-4 py-3 text-[10px] font-bold text-slate-500 uppercase">{student.course_name}</td>
                  <td className="px-4 py-3 text-[10px] font-bold text-slate-500 uppercase">{student.status}</td>
                  <td className="px-6 py-3 text-right">
                    <div className="flex justify-end gap-1">
                      <button onClick={() => onPrint(student)} className="p-1.5 text-slate-400 hover:text-orange-600"><Printer size={16} /></button>
                      <button onClick={() => onView(student)} className="p-1.5 text-slate-400 hover:text-blue-500"><Eye size={16} /></button>
                      <button onClick={() => onEdit(student)} className="p-1.5 text-slate-400 hover:text-orange-500"><Edit2 size={16} /></button>
                      <button onClick={() => onDelete(student)} className="p-1.5 text-slate-400 hover:text-red-500"><Trash2 size={16} /></button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Footer controls */}
      {totalPages > 1 && (
        <div className="flex items-center justify-between px-6 py-4 bg-white border-t border-slate-100 sm:flex-row flex-col gap-3">
          <div className="text-sm text-slate-500 font-medium">
            Page <span className="font-bold text-slate-800">{currentPage}</span> of{" "}
            <span className="font-bold text-slate-800">{totalPages}</span>
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="px-4 py-1.5 text-xs font-bold text-slate-600 bg-slate-50 border border-slate-200 rounded-lg hover:bg-slate-100 disabled:opacity-50 disabled:hover:bg-slate-50 transition-all"
            >
              Previous
            </button>
            <button
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="px-4 py-1.5 text-xs font-bold text-white bg-orange-500 rounded-lg hover:bg-orange-600 disabled:opacity-50 disabled:hover:bg-orange-500 transition-all"
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
}